import React from "react";
import clsx from "clsx";
import { Dialog, DialogContent } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isFunction } from "@util/utils";
import { TodoManager } from "@icoach/components";

const TodoDialog = React.forwardRef((props, ref) => {
	const { open, className, sourceData, onClose, refresh } = props;
	if (!open) return null;
	const { todos, memberID, options } = sourceData || {};

	const todoRef = React.useRef(null);

	const handleClose = () => {
		isFunction(refresh) && refresh(todoRef.current && todoRef.current.getTodos());
		isFunction(onClose) && onClose();
	};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={handleClose}>待辦事項</GradientColorHeader>
			<DialogContent>
				<TodoManager ref={todoRef} memberID={memberID} todos={todos} options={options} showInput />
			</DialogContent>
		</Dialog>
	);
});

export default TodoDialog;
